"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Header_1 = require("./components/Header");
var styles = require("./Console.css");
var Image_1 = require("../../atoms/Image");
var ContainerLoader_1 = require("../../atoms/ContainerLoader/ContainerLoader");
var Console = /** @class */ (function (_super) {
    __extends(Console, _super);
    function Console() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Console.prototype.getConsoleContent = function () {
        if (this.props.options && this.props.options.isLoading) {
            return (React.createElement(ContainerLoader_1.default, null));
        }
        else {
            return (this.props.children);
        }
    };
    Console.prototype.render = function () {
        return (React.createElement("div", __assign({ "data-test-id": this.props.testId }, this.getContainerStyles()),
            this.props.options && this.props.options.consoleImage &&
                React.createElement(Image_1.default, { data: { url: this.props.options.consoleImage }, options: { className: styles.consoleImage } }),
            this.getConsoleContent()));
    };
    Console.prototype.getContainerStyles = function () {
        return {
            className: this.getContainerClasses(),
            style: this.getContainerInlineStyle(this.props.options),
        };
    };
    Console.prototype.getContainerClasses = function () {
        return [styles.console, this.getBackgroundFromOps(this.props.options)].join(' ');
    };
    Console.prototype.getBackgroundFromOps = function (options) {
        if (options === void 0) { options = {}; }
        return options.backgroundImage ? styles.consoleBackgroundImage : null;
    };
    Console.prototype.getContainerInlineStyle = function (options) {
        if (options === void 0) { options = {}; }
        if (options.backgroundColor) {
            return {
                backgroundColor: options.backgroundColor,
            };
        }
        else if (options.backgroundImage) {
            return {
                backgroundImage: "url(" + options.backgroundImage + ")",
            };
        }
        return null;
    };
    Console.Header = Header_1.default;
    return Console;
}(React.Component));
exports.default = Console;
//# sourceMappingURL=Console.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/Console.js
// module id = 1349
// module chunks = 8